// extracted by mini-css-extract-plugin
module.exports = {"clearPayMessage__block":"ClearPayMessage_clearPayMessage__block__O1CgS","clearPayMessage__spinner":"ClearPayMessage_clearPayMessage__spinner__zXzVn"};